<article class="article-card">
  <a
    class="article-card__author"
    uiSref="profile.about"
    [uiParams]="{ profileId: article.user.slug }"
  >
    <ut-avatar-badges [user]="article.user"></ut-avatar-badges>
    <div class="article-card__author-meta">
      <span class="article-card__author-name">{{ article.user.name }}</span>
      @if (article.user.country?.name) {
        <span class="article-card__author-detail">{{ article.user.country.name }}</span>
      }
      @if (article.user.user_title) {
        <span class="article-card__author-detail">{{ article.user.user_title }}</span>
      }
    </div>
  </a>

  <p class="article-card__title">
    <a uiSref="singlearticle" [uiParams]="{ articleId: article.slug }" [innerHTML]="article.title | emojiHtml"></a>
  </p>

  <div class="article-card__footer">
    <time class="article-card__timestamp" [attr.datetime]="article.published_at">{{ article.published_at | relativeDate }}</time>
    <div class="article-card__actions">
      <ut-community-feed-item-like-count [likeable]="article"></ut-community-feed-item-like-count>
      <ut-community-feed-item-like-btn [likeable]="article"></ut-community-feed-item-like-btn>
      <ut-comment-btn [commentable]="article"></ut-comment-btn>
    </div>
  </div>
</article>
